/**
 * Presence of blueprint Mapbox layers after a style reload.
 */
export type BlueprintStylePresence = {
  underlayVisible: boolean;
  hasElevatedLayer: boolean;
  hasOutlineSource: boolean;
  hasOutlineLayer: boolean;
  hasHandlesLayer: boolean;
  hasCalibrateSource: boolean;
  hasCalibrateLineLayer: boolean;
};

/**
 * True when a visible underlay must rewrite GeoJSON after `styledata`.
 * Style reloads can recreate empty outline/calibrate sources while the custom
 * elevated layer still exists.
 */
export const shouldResyncBlueprintAfterStyleData = (
  presence: BlueprintStylePresence,
): boolean => {
  if (!presence.underlayVisible) return false;
  return (
    !presence.hasElevatedLayer ||
    !presence.hasOutlineSource ||
    !presence.hasOutlineLayer ||
    !presence.hasHandlesLayer ||
    !presence.hasCalibrateSource ||
    !presence.hasCalibrateLineLayer
  );
};
